import React from 'react';
import RuleFrame from './shared/RuleFrame';
import { mapBlockToRuleFrameProps } from './shared/helpers';
var PlaceholderLiteral = function (renderProps) {
    return (React.createElement(RuleFrame, { renderProps: mapBlockToRuleFrameProps(renderProps) },
        React.createElement(React.Fragment, null)));
};
export default PlaceholderLiteral;
//# sourceMappingURL=PlaceholderLiteral.js.map